import { BlockchainContext } from "../context/BlockchainContext";
import { useContext, useState, useRef, useEffect } from "react";
import CardImage from "../Images/fnft.png";
export default function LockedStaking() {
  const {
    currentAccount,
    useRef,
    onDeposit,
    depositRef,
    depositTokens,
    withdrawTokens,
    onWithDraw,
    withdrawRef,
    connectWallet,
    claimToken,
    approveLockedStake,
    depositLockedTokens,
    withdrawLockedTokens,
    emergencyWithdraw,
    withdrawLockedRewards,
  } = useContext(BlockchainContext);
  async function refreshPage() {
    {
      connectWallet();
    }
  }
  useEffect(() => {
    connectWallet();
  }, []);

  return (
    <div className="centerGrid">
      <div className="PoolCardBG">
        <div className="PoolCardHeader">
          Staking Pool 7 day lock
          <img src={CardImage} className="imageCard"></img>
        </div>
        <div className="PoolCardButton" onClick={approveLockedStake}>
          Approve
        </div>
        <div className="PoolCardBox">
          <div>APY</div>
          <div id="lockedAPR">%</div>
        </div>
        <div className="PoolCardBox">
          {" "}
          <div>Total Staked</div>
          <div id="totalLockedStake"></div>
        </div>{" "}
        <div className="PoolCardBox">
          <div>Early Jeet Tax</div> <div id="exitPenaltyPerc">%</div>
        </div>
        <div className="PoolCardBox">
          <div className="gridboxleft">
            Your Locked Tokens{" "}
            <div className="gridboxright" id="userLocked">
              0
            </div>
          </div>
        </div>
        <div className="PoolCardBox">
          {" "}
          <div className="gridboxleft">
            Pending Rewards{" "}
            <div className="gridboxright" id="lockedPendingRewards">
              0
            </div>{" "}
          </div>
        </div>{" "}
        {/* 
        <form className="gridbox" onChange={onWithDraw}>
          <input
            className="PoolCardButton"
            placeholder="INPUT VALUE"
            ref={withdrawRef}
            type="number"
          />
          <button
            className="PoolCardButton"
            onClick={withdrawLockedRewards}
            type="submit"
          >
            Claim
          </button>
        </form>*/}
        <div className="PoolCardBox">
          <form className="gridboxleft" onChange={onDeposit}>
            <input
              className="gridinput"
              placeholder="INPUT VALUE"
              ref={depositRef}
              type="number"
            />{" "}
            <div className="gridboxright">
              <button
                className="PoolCardButton"
                onClick={depositLockedTokens}
                type="submit"
              >
                DEPOSIT
              </button>{" "}
            </div>
          </form>{" "}
        </div>
        <div className="PoolCardBox">
          <div className="gridboxleft">
            Are you a jeet?
            <div className="gridboxright">
              <div className="PoolCardButton" onClick={emergencyWithdraw}>
                I am Jeet
              </div>{" "}
            </div>
          </div>
        </div>
        <div className="PoolCardBox">
          {" "}
          <div className="gridboxleft">
            Lock Period is over{" "}
            <div className="gridboxright">
              <button
                className="PoolCardButton"
                onClick={withdrawLockedTokens}
                type="submit"
              >
                Withdraw
              </button>{" "}
            </div>{" "}
          </div>
        </div>{" "}
        <div className="PoolCardBox" id="holderUnlockTime">
          <div className="gridboxleft">
            Your Unlock Date{" "}
            <div className="gridboxright">
              <div className="PoolCardButton" onClick={refreshPage}>
                check unlock date
              </div>{" "}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="nullBox">
        <div id="BNBpending"></div>
        <div id="APR"></div>
        <div id="StakedTokens"></div>
        <div id="balance"></div>
        <div id="pendingRewards"></div>
        <div id="depositedTokens"></div>
        <div id="earned"></div>
        <div id="getstakednfts"></div>
        <div id="costofmint"></div>
        <div id="totalSupply"></div>
        <div id="maxSupply"></div>
        <div id="totalnftstaked"></div>
        <div id="earned"></div>
        <div id="userLocked"></div>
        <div id="lockedPendingRewards"></div>
        <div id="holderUnlockTime"></div>
        <div id="lockedAPR"></div> <div id="totalLockedStake"></div>{" "}
        <div id="exitPenaltyPerc"></div> <div id="LockedTokenBalance"></div>{" "}
        <div className="nullBox">
          <div id="APR"></div>
          <div id="StakedTokens"></div>
          <div id="balance"></div>
          <div id="pendingRewards"></div>
          <div id="depositedTokens"></div>
          <div id="earned"></div>
          <div id="getstakednfts"></div>
          <div id="costofmint"></div>
          <div id="totalSupply"></div>
          <div id="maxSupply"></div>
          <div id="totalnftstaked"></div>
          <div id="earned"></div>
          <div id="userLocked"></div>
          <div id="rewardBalance"></div>
          <div id="balanceOfNFT"></div>
          <div id="lockedPendingRewards"></div>
          <div id="holderUnlockTime"></div>
          <div id="lockedAPR"></div> <div id="totalLockedStake"></div>{" "}
          <div id="exitPenaltyPerc"></div> <div id="LockedTokenBalance"></div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
}
